import { authHeader } from '../helpers';
import { defineConfig } from '../config'
import { utilsService } from './utils'
const { handleResponse } = utilsService

export const tokenService = {
  tokenAuth,
};

const { apiUrl, apiVer } = defineConfig.TOKEN_SERVICE

function getApiPath() {
  return (apiUrl + apiVer + "/token")
}

function tokenAuth(token) {
  const url = getApiPath() + "/auth/" + token;

  const requestOptions = {
    method: "POST",
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}